/**
 * use-feedback.ts — Nút bong bóng "Góp ý": POST /feedback (máy chủ ghi ra file JSONL để đội phát triển theo dõi).
 */
import { useMutation } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import type { FeedbackPayload } from '@/lib/feedback'

export function useSendFeedback() {
  return useMutation({
    mutationFn: async (payload: FeedbackPayload) => (await api.post<{ ok: boolean; id: string }>('/feedback', payload)).data,
  })
}
